import { useMemo, useRef } from 'react';
import { Bar } from 'react-chartjs-2';
import { ChartData, ChartOptions } from 'chart.js';
import { ChartComponentProps, BarChartHookReturn } from './types';
import { generateBasicChartData } from './dataUtils';
import { createChartOptions } from './chartConfig';
import { AggregatedOrderViewType } from 'src/gql/graphql';

export const useHorizontalBarChart = ({
  table,
  grouping,
  rowSelection,
  setRowSelection,
  borderColor,
  textColor,
}: ChartComponentProps): BarChartHookReturn => {
  const chartRef = useRef<any>(null);

  const chartData = useMemo(() => {
    return generateBasicChartData(
      table,
      grouping,
      rowSelection,
      AggregatedOrderViewType.HorizontalBarChart
    ) as ChartData<'bar'>;
  }, [
    table.options.data,
    table.getState().columnFilters,
    table.getState().grouping,
    grouping,
    rowSelection,
  ]);

  const chartOptions = useMemo((): ChartOptions<'bar'> => {
    return createChartOptions(
      AggregatedOrderViewType.HorizontalBarChart,
      borderColor,
      textColor,
      table,
      rowSelection,
      setRowSelection
    ) as ChartOptions<'bar'>;
  }, [
    borderColor,
    textColor,
    table.options.data,
    table.getState().columnFilters,
    table.getState().grouping,
    rowSelection,
    setRowSelection,
  ]);

  return {
    chartData,
    chartOptions,
    chartRef,
  };
};

export default function HorizontalBarChart(props: ChartComponentProps) {
  const { chartData, chartOptions, chartRef } = useHorizontalBarChart(props);

  return <Bar data={chartData} options={chartOptions} ref={chartRef as any} />;
}
